/* ============================================================
   Click-to-enlarge for PT · Proof gallery bands that opt in.

   The section tag is emitted once per opted-in band, so this file can be
   requested several times on one page; everything below is guarded to run
   exactly once. Delegation means bands rendered later by the theme editor
   are picked up with no re-init.
   ============================================================ */
(function () {
  "use strict";
  if (window.__ptLightbox) return;
  window.__ptLightbox = true;

  /* The section emits one of these tags per opted-in band, so the stylesheet
     is attached here, once, instead of repeating the <link> in the head. */
  (function () {
    var tag = document.querySelector("script[data-pt-lightbox-css]");
    var href = tag && tag.getAttribute("data-pt-lightbox-css");
    if (!href || document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  })();

  var lb = null, imgEl = null, stageEl = null, capEl = null, prevEl = null, nextEl = null;
  var shots = [], idx = -1, lastFocus = null;

  function build() {
    lb = document.createElement("div");
    lb.className = "pt-lb";
    lb.setAttribute("role", "dialog");
    lb.setAttribute("aria-modal", "true");
    lb.innerHTML =
      '<button type="button" class="pt-lb__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="pt-lb__nav pt-lb__nav--prev" aria-label="Previous">&#8249;</button>' +
      '<button type="button" class="pt-lb__nav pt-lb__nav--next" aria-label="Next">&#8250;</button>' +
      '<figure class="pt-lb__fig">' +
        '<div class="pt-lb__stage"><img class="pt-lb__img" alt=""></div>' +
        '<figcaption class="pt-lb__cap"></figcaption>' +
      '</figure>';
    document.body.appendChild(lb);
    imgEl = lb.querySelector(".pt-lb__img");
    stageEl = lb.querySelector(".pt-lb__stage");
    capEl = lb.querySelector(".pt-lb__cap");
    prevEl = lb.querySelector(".pt-lb__nav--prev");
    nextEl = lb.querySelector(".pt-lb__nav--next");

    lb.querySelector(".pt-lb__close").addEventListener("click", close);
    prevEl.addEventListener("click", function (e) { e.stopPropagation(); step(-1); });
    nextEl.addEventListener("click", function (e) { e.stopPropagation(); step(1); });
    /* backdrop only — clicks on the photo itself must not dismiss it */
    lb.addEventListener("click", function (e) { if (e.target === lb) close(); });

    bindZoom();
  }

  /* ---------------------------------------------------------------- zoom
     Fitting the photo to the screen is only a little larger than the
     thumbnail it came from, so the fitted view is the *starting* point and
     the image zooms past it, with drag to pan.

     Clicks walk a ladder rather than jumping straight to the ceiling. The
     first rung is deliberately gentle — the photo grows but stays within
     the window, so nothing is lost off the edges and the step is easy to
     undo. Only the second rung goes in far enough to need panning. A
     further click returns to the whole photo.

     The top rung is derived per photo from the file's real pixels, so a
     big file allows a longer reach and a small one stops before it turns
     to mush. */
  var scale = 1, tx = 0, ty = 0, MAXS = 2.2;
  var STEPS = [1, 1.35, 2.2];
  var dragging = false, moved = false, sx = 0, sy = 0, stx = 0, sty = 0;

  function applyT(animate) {
    /* The transform rides on a wrapper rather than the <img> itself, so the
       image keeps its own max-width/max-height fitting and object-fit while
       the wrapper handles scale and pan. */
    stageEl.style.transition = animate ? "transform .22s ease" : "none";
    stageEl.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
    lb.classList.toggle("pt-lb--zoomed", scale > 1.01);
  }

  function resetZoom(animate) { scale = 1; tx = 0; ty = 0; applyT(animate); }

  /* Keep the photo from being dragged off screen: allow panning only over
     the overflow the current scale actually creates. */
  function clamp() {
    var r = imgEl.getBoundingClientRect();
    var w = r.width / scale, h = r.height / scale;
    var mx = Math.max(0, (w * scale - lb.clientWidth) / 2);
    var my = Math.max(0, (h * scale - lb.clientHeight) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
  }

  function zoomAt(cx, cy, next) {
    next = Math.min(MAXS, Math.max(1, next));
    var r = imgEl.getBoundingClientRect();
    /* the point under the cursor stays under the cursor */
    var ox = cx - (r.left + r.width / 2);
    var oy = cy - (r.top + r.height / 2);
    var k = next / scale;
    tx = tx - ox * (k - 1);
    ty = ty - oy * (k - 1);
    scale = next;
    if (scale === 1) { tx = 0; ty = 0; }
    clamp();
    applyT(true);
  }

  function bindZoom() {
    stageEl.addEventListener("click", function (e) {
      e.stopPropagation();
      if (moved) { moved = false; return; }      /* a pan, not a click */
      /* The stage fills the window so the photo can be centred in it, which
         means the dark area around the photo is the stage rather than the
         backdrop. Anything that is not the photo itself closes, the way a
         click beside a lightboxed image is expected to. */
      if (e.target !== imgEl) { close(); return; }
      /* next rung up, wrapping back to the whole photo past the last */
      var next = STEPS[0];
      for (var i = 0; i < STEPS.length; i++) {
        if (STEPS[i] > scale + 0.01) { next = STEPS[i]; break; }
      }
      zoomAt(e.clientX, e.clientY, next);
    });
    stageEl.addEventListener("dblclick", function (e) { e.preventDefault(); });

    lb.addEventListener("wheel", function (e) {
      if (!lb.classList.contains("pt-lb--open")) return;
      e.preventDefault();
      zoomAt(e.clientX, e.clientY, scale * (e.deltaY < 0 ? 1.18 : 1 / 1.18));
    }, { passive: false });

    stageEl.addEventListener("pointerdown", function (e) {
      if (scale <= 1.01) return;
      dragging = true; moved = false;
      sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
      stageEl.setPointerCapture(e.pointerId);
    });
    stageEl.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
      tx = stx + dx; ty = sty + dy;
      clamp(); applyT(false);
    });
    ["pointerup", "pointercancel"].forEach(function (ev) {
      stageEl.addEventListener(ev, function () { dragging = false; });
    });
  }

  function show(i) {
    if (!shots.length) return;
    idx = (i + shots.length) % shots.length;
    var btn = shots[idx];
    resetZoom(false);
    imgEl.src = btn.getAttribute("data-zoom-src");
    imgEl.alt = btn.getAttribute("data-zoom-alt") || "";
    /* recomputed per photo once the file reports its real width */
    imgEl.onload = function () {
      var fitW = imgEl.getBoundingClientRect().width / (scale || 1);
      var native = imgEl.naturalWidth / Math.max(1, fitW);   /* 1 = pixel for pixel */
      /* A little past 1:1 is still worth having — that is where a phone
         lands too — but far past it is only blur. */
      MAXS = Math.max(1.8, Math.min(2.6, native * 1.3));
      /* the gentle rung stays put; only the far rung follows the file */
      STEPS = [1, 1.35, MAXS];
    };
    var cap = btn.getAttribute("data-zoom-cap") || "";
    capEl.textContent = cap;
    capEl.style.display = cap ? "" : "none";
    var many = shots.length > 1;
    prevEl.hidden = !many;
    nextEl.hidden = !many;
  }

  function step(d) { show(idx + d); }

  function open(btn) {
    if (!lb) build();
    /* Siblings within the same band, so next/prev walks that series rather
       than jumping across every gallery on the page. */
    var band = btn.closest(".pt-prooftrack") || document;
    shots = Array.prototype.slice.call(band.querySelectorAll("[data-zoom-src]"));
    lastFocus = document.activeElement;
    show(shots.indexOf(btn));
    lb.classList.add("pt-lb--open");
    document.documentElement.style.overflow = "hidden";
    lb.querySelector(".pt-lb__close").focus();
  }

  function close() {
    if (!lb) return;
    lb.classList.remove("pt-lb--open");
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    /* drop the source after the fade so the next open cannot flash the old
       photo, and a big file is not held in memory while closed */
    setTimeout(function () { if (!lb.classList.contains("pt-lb--open")) imgEl.removeAttribute("src"); }, 260);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-zoom-src]");
    if (btn) { e.preventDefault(); open(btn); }
  });

  document.addEventListener("keydown", function (e) {
    if (!lb || !lb.classList.contains("pt-lb--open")) return;
    var cx = lb.clientWidth / 2, cy = lb.clientHeight / 2;
    if (e.key === "Escape") { e.preventDefault(); close(); }
    else if (e.key === "+" || e.key === "=") { e.preventDefault(); zoomAt(cx, cy, scale * 1.4); }
    else if (e.key === "-" || e.key === "_") { e.preventDefault(); zoomAt(cx, cy, scale / 1.4); }
    else if (e.key === "0") { e.preventDefault(); resetZoom(true); }
    /* while zoomed the arrows pan the photo; stepping to the next shot would
       throw away the detail the visitor just went looking for */
    else if (e.key === "ArrowRight") { e.preventDefault(); if (scale > 1.01) { tx -= 60; clamp(); applyT(true); } else step(1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); if (scale > 1.01) { tx += 60; clamp(); applyT(true); } else step(-1); }
  });
})();
